"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFile = exports.getDownloadUrlFromArchive = exports.deleteEvaluationFiles = exports.deleteFile = exports.uploadFilesForEvaluation = exports.uploadZipFromBlob = exports.uploadFile = exports.saveFromStorage = exports.downloadBlobFromPath = void 0;
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var axios_1 = __importDefault(require("axios"));
var file_saver_1 = __importDefault(require("file-saver"));
var jszip_1 = __importDefault(require("jszip"));
var lodash_1 = __importDefault(require("lodash"));
var fbase_1 = require("../firebase/fbase");
var BatchPromises_1 = require("../utils/BatchPromises");
function getDownloadUrl(path) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbase_1.storageService.ref().child(path).getDownloadURL()];
                case 1: 
                // Cloud Storage 에서 fileFullPath 의 download url 을 가져온다.
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function downloadBlobFromPath(path) {
    return __awaiter(this, void 0, void 0, function () {
        var downloadUrl, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getDownloadUrl(path)];
                case 1:
                    downloadUrl = _a.sent();
                    return [4 /*yield*/, axios_1.default.get(downloadUrl, { responseType: 'blob' })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, new Blob([response.data], {
                            type: response.headers['content-type']
                        })];
            }
        });
    });
}
exports.downloadBlobFromPath = downloadBlobFromPath;
function saveFromStorage(path, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, downloadBlobFromPath(path)];
                case 1:
                    blob = _a.sent();
                    file_saver_1.default.saveAs(blob, fileName);
                    return [2 /*return*/];
            }
        });
    });
}
exports.saveFromStorage = saveFromStorage;
// TODO(sangmuk):convertEvaluationToJson 잘 동작하는지 확인
function uploadFile(filePath, fileData) {
    return __awaiter(this, void 0, void 0, function () {
        var storageRef, fileRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storageRef = fbase_1.storageService.ref();
                    fileRef = storageRef.child(filePath);
                    return [4 /*yield*/, fileRef.put(fileData)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.uploadFile = uploadFile;
function uploadZipFromBlob(filePath, objList) {
    return __awaiter(this, void 0, void 0, function () {
        var zip, content, storageRef, fileRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    zip = new jszip_1.default();
                    objList.forEach(function (obj) {
                        var fileName = obj.fileName;
                        var fileType = obj.fileTypeInZip;
                        var blobData = obj.fileBlob;
                        zip.file("".concat(fileType, "/").concat(fileName), blobData, { binary: true });
                    });
                    return [4 /*yield*/, zip.generateAsync({ type: 'blob' })];
                case 1:
                    content = _a.sent();
                    storageRef = fbase_1.storageService.ref();
                    fileRef = storageRef.child(filePath);
                    return [4 /*yield*/, fileRef.put(content)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.uploadZipFromBlob = uploadZipFromBlob;
function uploadFilesForEvaluation(evalType, files) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                /*
                파일들을 Storage 에 업로드
                @param: evalType: String - 평가 종류 / "OE"(운영평가), "DE"(설계평가)
                @param: fileObjectArr: Object[] evaluationParsingInfoUploadFileList 에서 받은 리턴 값 그대로
                */
                return [4 /*yield*/, (0, BatchPromises_1.promiseAllInBatches)(function (fileObject) { return __awaiter(_this, void 0, void 0, function () {
                        var filePath;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    filePath = lodash_1.default.join([
                                        Evaluation.getKoEvaluation(evalType),
                                        fileObject.evaluationName,
                                        fileObject.controlId,
                                        fileObject.name
                                    ], '/');
                                    if (!fileObject.file) return [3 /*break*/, 2];
                                    return [4 /*yield*/, uploadFile(filePath, fileObject.file)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, files, 50)];
                case 1:
                    /*
                    파일들을 Storage 에 업로드
                    @param: evalType: String - 평가 종류 / "OE"(운영평가), "DE"(설계평가)
                    @param: fileObjectArr: Object[] evaluationParsingInfoUploadFileList 에서 받은 리턴 값 그대로
                    */
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.uploadFilesForEvaluation = uploadFilesForEvaluation;
function deleteFile(filePath) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // 파일 하나를 Storage 에서 삭제
                return [4 /*yield*/, fbase_1.storageService.ref().child(filePath).delete()];
                case 1:
                    // 파일 하나를 Storage 에서 삭제
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.deleteFile = deleteFile;
function deleteDirectory(directoryPath) {
    return __awaiter(this, void 0, void 0, function () {
        var storageRef, files;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storageRef = fbase_1.storageService.ref();
                    return [4 /*yield*/, storageRef.child(directoryPath).list()];
                case 1:
                    files = _a.sent();
                    return [4 /*yield*/, Promise.all(files.items.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, storageRef.child(item.fullPath).delete()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var deleteEvaluationFiles = function (evalType, evalName) { return __awaiter(void 0, void 0, void 0, function () {
    var filePath, directoryObject, directories;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filePath = "".concat(Evaluation.getKoEvaluation(evalType), "/").concat(evalName);
                return [4 /*yield*/, fbase_1.storageService.ref().child(filePath).list()];
            case 1:
                directoryObject = _a.sent();
                directories = lodash_1.default.map(directoryObject.prefixes, function (prefix) { return prefix.fullPath; });
                return [4 /*yield*/, Promise.all(lodash_1.default.map(directories, function (directoryPath) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, deleteDirectory(directoryPath)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteEvaluationFiles = deleteEvaluationFiles;
function getDownloadUrlFromArchive(evalType, refEvalName, controlIds) {
    return __awaiter(this, void 0, void 0, function () {
        var storageRef, targetDirRef, childFileListRef, childFileList, values;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storageRef = fbase_1.storageService.ref();
                    targetDirRef = storageRef.child("Archive/".concat(Evaluation.getKoEvaluation(evalType), "/").concat(refEvalName));
                    return [4 /*yield*/, targetDirRef.list()];
                case 1:
                    childFileListRef = _a.sent();
                    childFileList = childFileListRef.items;
                    return [4 /*yield*/, (0, BatchPromises_1.promiseAllInBatches)(function (storageFileObject) { return __awaiter(_this, void 0, void 0, function () {
                            var fileName, fileFullPath, controlId, url;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fileName = storageFileObject.name;
                                        fileFullPath = storageFileObject.fullPath;
                                        controlId = fileName.split('.zip')[0];
                                        if (!lodash_1.default.includes(controlIds, controlId)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, getDownloadUrl(fileFullPath)];
                                    case 1:
                                        url = _a.sent();
                                        return [2 /*return*/, {
                                                controlId: controlId,
                                                url: url
                                            }];
                                    case 2: return [2 /*return*/, undefined];
                                }
                            });
                        }); }, childFileList, 50)];
                case 2:
                    values = _a.sent();
                    return [2 /*return*/, lodash_1.default.reduce(lodash_1.default.compact(values), function (result, value) {
                            result[value.controlId] = value.url;
                            return result;
                        }, {})];
            }
        });
    });
}
exports.getDownloadUrlFromArchive = getDownloadUrlFromArchive;
function hasFile(evalType, evaluationName, controlId, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var storageRef, path, downloadUrl, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storageRef = fbase_1.storageService.ref();
                    path = [Evaluation.getKoEvaluation(evalType), evaluationName, controlId, fileName].join('/');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, storageRef.child(path).getDownloadURL()];
                case 2:
                    downloadUrl = _a.sent();
                    return [2 /*return*/, !lodash_1.default.isEmpty(downloadUrl)];
                case 3:
                    e_1 = _a.sent();
                    console.log('Not found ', evaluationName, controlId, fileName);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.hasFile = hasFile;
//# sourceMappingURL=StorageManager.js.map